export default from './card-overlay';



// WEBPACK FOOTER //
// ./app/components/card-overlay/index.js